// extracted by mini-css-extract-plugin
export default {"banner":"CookieBanner_banner__A4qkb","content":"CookieBanner_content__M-cLS","btn":"CookieBanner_btn__HzCaO"};